// extracted by mini-css-extract-plugin
module.exports = {"question_button":"mra_question_button__OpI_F"};